import { MinimalLayoutContainer, MinimalLayoutContent } from './component';

export const MinimalLayout = {
    Container: MinimalLayoutContainer,
    Content: MinimalLayoutContent,
};
